import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import {
  PREFERRED_BANKERS_PROMPT,
} from '../../constants/promptMessages';

import List from './List';

export default class ProjectSpecifications extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = checkChanges(List, { message: PREFERRED_BANKERS_PROMPT })

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: [],
      count: 0,
    };
  }
  componentDidMount() {
    this.fetchPreferredBankers();
  }
  setBankers(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchPreferredBankers() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/bankers/preferred/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const data = await res.json();
      await this.setBankers(data);
      // handle token.. etc
      await this.setComponentState({
        token,
        count,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        loading: this.state.loading,
        data: this.state.data,
        count: this.state.count,
        fetch: () => {
          this.fetchPreferredBankers();
        },
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PreferredBankers/PreferredBankers.jsx